import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { Modulo10Validator } from './utils/modulo10.validator';

export class MarktlokationIdValidator {
    private static readonly MARKTLOKATION_ID_PATTERN = new RegExp('^[1-9]\\d{10}$');

    static validate(): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            if (!control.value) {
                return null;
            }

            if (!control.value || !control.value.toString().match(this.MARKTLOKATION_ID_PATTERN)) {
                return { pattern: true };
            } else if (!this.isCheckDigitCalculationValid(control.value.toString())) {
                return { checkDigit: true };
            }

            return null;
        };
    }

    private static isCheckDigitCalculationValid(marktlokationId: string): Boolean {
        const convertedId = this.convertIdToNumberValues(marktlokationId);
        return Modulo10Validator.isValid(convertedId);
    }

    private static convertIdToNumberValues(marktlokationId: string): number[] {
        return [
            ...marktlokationId,
        ].map(value => parseInt(value));
    }
}
